// src/api/flexPrices.js
import api from "./axios";

// Fetch all flex prices
export async function getFlexPrices() {
  const res = await api.get("/flexprices");
  return res.data;
}

// Create or update a flex price
export async function upsertFlexPrice(rate) {
  if (rate._id) {
    // update existing
    const res = await api
      .put(`/flexprices/${rate._id}`, {
        group: rate.group,
        rateExVAT: parseFloat(rate.rateExVAT),
      });
    return res.data;
  }
  // create new
  const res_1 = await api
    .post("/flexprices", {
      group: rate.group,
      rateExVAT: parseFloat(rate.rateExVAT),
    });
  return res_1.data;
}

// Delete a flex price by ID
export function deleteFlexPrice(id) {
  return api.delete(`/flexprices/${id}`);
}
